module.exports = __webpack_public_path__ + "static/media/tick.3a2306c7.png";